import GavelOutlinedIcon from '@mui/icons-material/GavelOutlined';
import { createFileRoute } from '@tanstack/react-router';

import { LoginDenialScreen } from '#components/login-denial-screen/login-denial-screen.js';
import { LoginDenialTone } from '#components/login-denial-screen/login-denial-tone.js';

export const Route = createFileRoute('/_authorization-gate/documents-pending/')({
	head: () => ({ meta: [{ title: 'Acceptance required • Cadstrom' }] }),
	component: DocumentsPendingPage,
});

/**
 * Landing screen for a login denied because the organization has legal documents
 * awaiting acceptance and this user may not accept them. Reached when the Auth0
 * Post-Login gate denies with the `document_compliance` code (see
 * auth0-callback-page.tsx). Points at the administrator and offers a retry — a
 * fresh login re-runs the gate, which passes once an administrator has accepted.
 */
export function DocumentsPendingPage() {
	return (
		<LoginDenialScreen
			icon={<GavelOutlinedIcon className='text-[1.375rem]' />}
			tone={LoginDenialTone.Warning}
			title='Acceptance required'
			message='Access is paused until an administrator of your organization accepts Cadstrom’s updated legal documents. Ask them to log in and accept, then try again.'
			loginLabel='Log in'
		/>
	);
}
